<template>
  <div class="statistics-return--container no-select">
    <div class="section-title mrg-t-25">Отчет</div>

    <div v-if="loadedStat && statData.length" class="statistics-return--report-container">
      <div class="statistics-return--cards mrg-t-10">
        <div class="table--container">
          <div class="table--header center">
            <div>Сотрудник</div>
            <div>Всего клиентов за период</div>
            <div>Новые клиенты за период</div>
            <div>Вернувшиеся клиенты за период</div>
            <div>Клиентов за 60 дней до {{periodDateFrom}}</div>
            <div>Из них вернулись с {{periodDateFrom}} по {{periodDateTo}}</div>
          </div>
          <div class="table--rows stripped">
            <div
                class="table--row center"
                v-for="item in statData"
                :key="item.id"
            >
              <div>
                <span>{{item.name}}</span>
                <span v-if="item.deleted == 1"> (удален)</span>
              </div>
              <div>{{item.all_clients}}</div>
              <div>{{item.new_clients_count}} ({{item.new_client_percent}}%)</div>
              <div>{{item.returnal_client_count}} ({{item.returnal_client_percent}}%)</div>
              <div>{{item.days_back_clients_count}}</div>
              <div>{{item.returnal_days_back_client_count}} ({{item.returnal_days_back_client_percent}}%)</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="!loadedStat" class="statistics-return--no-date mrg-t-15 text-center">
      Выберите период
    </div>
    <div v-if="loadedStat && !statData.length" class="statistics-return--no-data mrg-t-15 text-center">
      Нет данных за выбранный период
    </div>
  </div>
</template>

<script>
import statisticsRepository from "../../../repositories/statistics";
import Formatter from "@/components/libraries/Formatter";
const formatter = new Formatter();

export default {
  name: "StatisticsReturnabillity",
  components: {},
  data() {
    return {
      loadedStat: false,
      statData: [],
    };
  },
  props: {
    periodDateFrom: String,
    periodDateTo: String,
    show: Boolean
  },
  watch: {
    show(val){
      if(val){
        this.checkDateAndLoad(this.periodDateFrom, this.periodDateTo, 'main');
      }
    },
    periodDateFrom: function(val){
      if(this.show){
        this.checkDateAndLoad(val, this.periodDateTo, 'main');
      }
    },
    periodDateTo: function(val){
      if(this.show){
        this.checkDateAndLoad(this.periodDateFrom, val, 'main');
      }
    }
  },
  computed: {
    isSelectedPeriod(){
      let result = false;
      if(this.periodDateFrom != '' && this.periodDateTo != ''){
        result = true;
      }
      return result;
    },
  },
  methods: {
    checkDateAndLoad(dateFrom, dateTo){
      if(dateFrom == '' || dateTo == ''){
        return false;
      }
      let dateFromObj = formatter.rusDateToJSObject(dateFrom);
      let dateToObj = formatter.rusDateToJSObject(dateTo);

      if(dateFromObj.getTime() > dateToObj.getTime()){
        this.$store.dispatch("addNotification", {
          text: 'Дата ОТ не может быть больше даты ДО',
          time: 3,
          color: "danger"
        });

        this.periodDateTo = '';
        this.statData = [];
        return false;
      }

      if( (formatter.millisecondsToDay(dateToObj.getTime() - dateFromObj.getTime())) > 185 ){
        this.$store.dispatch("addNotification", {
          text: 'Интервал должен быть не более 6 месяцев',
          time: 3,
          color: "danger"
        });

        this.periodDateTo = '';
        this.statData = [];
        return false;
      }

      this.getStatistics();
    },
    getStatistics(){
      this.$store.dispatch("startPreloader");

      statisticsRepository.getStat({
        type: 'returnability',
        dateFrom: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodDateFrom)),
        dateTo: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodDateTo))
      }).then(resp => {
        this.loadedStat = true;
        this.statData = resp.data.result;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {

  }
};
</script>

<style scoped lang="less">
.statistics-return--cards{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;
  margin-bottom: 30px;

  &>.card{
    width: 300px;
    margin-top: 5px;
    margin-right: 10px;

    .title{
      font-size: 15px;
      font-weight: 700;
    }
    .value{
      margin-top: 8px;
      font-size: 20px;
    }
    .hint{
      margin-top: 8px;
      font-size: 12px;
      color: gray;
    }
    .value-compare{
      margin-top: 10px;
      font-size: 13px;

      .compare-title{
        color: #F97979;
      }
      .compare-val{
        font-weight: 700;
      }
    }
  }
}
.statistics-return--no-date, .statistics-return--no-data{
  color: #F97979;
}
</style>
